<template>
    <span class="relative">
        <input class="absolute" style="left: -99999px;"
            type="file"
            name="files"
            :multiple="multiple"
            ref="files"
            @change="handleVaporUpload()"
            :disabled="disabled"
            :accept="accept" />
        <button type="button"
            class="bg-default-500 text-white text-xs py-1 px-3 relative"
            :class="{'opacity-50 cursor-not-allowed': disabled}"
            @click="addFiles()"
            v-if="!uploading"
            @drop.stop.prevent="drop"
        >
            <div class="absolute inset-0"
                @dragenter.prevent="dragenter"
                @dragleave.prevent="dragleave"
                @dragover.prevent
                @drop.stop.prevent="drop">
            </div>
            <font-awesome-icon class="text-white text-sm mr-2" :icon="['fal', 'upload']" />
            <span v-if="showDropzone">Drop to Upload</span>
            <span v-else>Upload</span>
        </button>
        <button type="button" class="bg-default-500 text-white text-xs py-1 px-3 opacity-50 cursor-not-allowed" v-if="uploading">
            Uploading, please wait...
        </button>
    </span>
</template>

<script>
import axios from 'axios';

export default {
    name: "FileUpload",
    props: {
        folder: { default: 'uploads' },
        multiple: { default: false },
        delay: { default: 0 },
        locked: { default: false },
        accept: { default: '*' },
        model: { default: null },
        id: { default: null },
        group: { default: null },
        selectedFolder: { default: null }
    },
    data: function(){
        return {
            files: [],
            uploading: false,
            percentCompleted: 0,
            disabled: false,
            showDropzone: false
        }
    },
    mounted() {
        if (this.locked){
            this.disabled = true;
        }
    },
    methods: {
        addFiles(){
            this.$refs.files.click();
        },
        handleVaporUpload: async function() {
            this.$emit('uploading');
            this.disabled = true;
            this.uploading = true;

            const uploadedFiles = this.$refs.files.files

            for (let i = 0; i < uploadedFiles.length; i++) {
                await this.store(uploadedFiles[i], {
                    progress: progress => {
                        this.uploadProgress = Math.round(progress * 100);
                    }
                }).then(response => {
                    const fileData = {
                        filename: uploadedFiles[i].name,
                        type: uploadedFiles[i].type,
                        size: uploadedFiles[i].size,
                        key: response.key,
                        extension: response.extension,
                        model: this.model,
                        id: this.id,
                        group: this.group,
                        selectedFolder: this.selectedFolder,
                        folder: this.folder
                    }

                    this.files.push(fileData);
                });
            }

            await axios.post(process.env.VUE_APP_API_URL + '/vapor/upload', {files: this.files}).then(response => {
                setTimeout(() => {
                    this.resetUpload();

                    if (response.data.success === true){
                        // only emit if successful
                        this.$emit('uploaded', response.data);

                        // success
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Success',
                            text: 'Upload Successful',
                            duration: 5000
                        });
                    } else {
                        this.$emit('error', response.data.message);

                        // notify the error
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Error',
                            text: 'Upload Error',
                            duration: 5000
                        });
                    }

                    this.disabled = false;
                    this.uploading = false;

                }, parseInt(this.delay));
            }).catch(() => {
                this.resetUpload();
            });
        },
        store: async function (file, options = null) {
            const response = await axios.post(process.env.VUE_APP_API_URL + '/vapor/signed-storage-url', {
                'bucket': options.bucket || '',
                'content_type': options.contentType || file.type,
                'expires': options.expires || ''
            });

            if (typeof options.progress === 'undefined') {
                options.progress = () => {};
            }
            // This is the fix for the headers. Instance just for the S3 PUT
            const instance = axios.create()
            instance.defaults.headers.common = {};

            const s3Response = await instance.put(response.data.url, file, {
                headers: response.data.headers,
                onUploadProgress: (progressEvent) => {
                    options.progress(progressEvent.loaded / progressEvent.total);
                }
            });

            response.data.extension = file.name.split('.').pop()

            return response.data;
        },
        handleUpload: function(){
            this.$emit('uploading');
            this.disabled = true;

            const axiosConfig = {
                headers: {'Content-Type': 'multipart/form-data'}
            };

            let uploadedFiles = this.$refs.files.files;

            for(let i = 0; i < uploadedFiles.length; i++ ){
                this.files.push( uploadedFiles[i] );
            }

            let formData = new FormData();
            formData.append('folder', this.folder);

            for (let x = 0; x < this.files.length; x++ ){
                let file = this.files[x];
                formData.append('files[' + x + ']', file);
            }

            this.uploading = true;

            formData.append('model', this.model);
            formData.append('id', this.id);
            formData.append('group', this.group);
            formData.append('selectedFolder', this.selectedFolder);

            axios.post(process.env.VUE_APP_API_URL + '/upload', formData, axiosConfig).then(response => {
                setTimeout(() => {

                    // reset the upload properties
                    this.resetUpload();

                    if(response.data.success === true){

                        // only emit if successful
                        this.$emit('uploaded', response.data);

                        // success
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Success',
                            text: 'Upload Successful',
                            duration: 5000
                        });

                    }else{
                        this.$emit('error', response.data.message);

                        // notify the error
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Error',
                            text: 'Upload Error',
                            duration: 5000
                        });
                    }

                }, parseInt(this.delay));
            }).catch(() => {
                this.resetUpload();

            });
        },
        resetUpload: function(){
            this.uploading = false;
            this.percentCompleted = 0;
            this.files = [];
            this.disabled = false;
        },
        dragenter: function(event){
            event.preventDefault()
            this.showDropzone = true
        },
        dragleave: function(event) {
            event.preventDefault()
            this.showDropzone = false
        },
        drop: function(event) {
            event.preventDefault()
            this.$refs.files.files = event.dataTransfer.files
            this.showDropzone = false
            this.handleVaporUpload()
        }
    },
    watch: {
        locked: function(newVal){
            this.disabled = newVal;
        }
    }
}
</script>

<style scoped>

</style>
